import React, { useMemo } from "react";

interface PlayButtonProps {
  className?: string;
  width?: number;
  height?: number;
  style?: React.CSSProperties;
}

export const PlayButton: React.FC<PlayButtonProps> = ({
  className,
  width = 68,
  height = 68,
  style,
}) => {
  const gradientId = useMemo(
    () => `playButtonGradient_${Math.random().toString(36).substr(2, 9)}`,
    [],
  );

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 68 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <g id="Atom / Play Button / Large Alt / Hover">
        <circle
          id="Ellipse 1"
          opacity="0.9"
          cx="34"
          cy="34"
          r="34"
          fill="#0C1318"
          fillOpacity="0.5"
        />
        <circle
          id="Ellipse 2"
          opacity="0.8"
          cx="34"
          cy="34"
          r="28.5"
          fill={`url(#${gradientId})`}
          stroke={`url(#${gradientId})`}
          strokeWidth="3"
        />
        <circle
          id="Ellipse 3"
          opacity="0.8"
          cx="34"
          cy="34"
          r="28.5"
          fill={`url(#${gradientId})`}
          stroke="#F7FCFD"
          strokeWidth="3"
        />
        <path
          id="Polygon 1"
          d="M45 32.2679C46.3333 33.0378 46.3333 34.9623 45 35.7321L30 44.3923C28.6667 45.1621 27 44.1999 27 42.6603L27 25.3397C27 23.8001 28.6667 22.8379 30 23.6077L45 32.2679Z"
          fill="#F8FCFF"
        />
      </g>
      <defs>
        <linearGradient
          id={gradientId}
          x1="64"
          y1="-1.14286"
          x2="-0.923198"
          y2="58.6548"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1278A1" />
          <stop offset="1" stopColor="#4DBD94" />
        </linearGradient>
      </defs>
    </svg>
  );
};
